import { Component } from '@angular/core';
import { KeycloakAuthService } from 'src/app/auth/keycloak.service';

@Component({
  standalone: false,
  selector: 'app-authorisaton-error',
  templateUrl: './authorisaton-error.component.html',
  styleUrls: ['./authorisaton-error.component.css']
})
export class AuthorisatonErrorComponent {
  buttonTitle: string = "Return to Login"
  constructor(private keycloakAuthService: KeycloakAuthService) {};
  
  async goBack(){
    await this.keycloakAuthService.login()
  }
}
